import { Icon } from '@fv/client-components'
import type { TrackDetail } from '@fv/client-types'

import { formatTrackingDateTime } from './utils'

type Props = {
  track?: TrackDetail
}
export const DeliveryAppointment = ({ track }: Props) => {
  if (
    !track?.deliveryDetails?.appointment ||
    track?.currentStatus === 'delivered'
  ) {
    return null
  }

  const begin =
    track.deliveryDetails.appointment.begins &&
    formatTrackingDateTime(track.deliveryDetails.appointment.begins)

  const end =
    track.deliveryDetails.appointment.ends &&
    formatTrackingDateTime(track.deliveryDetails.appointment.ends)

  if (!begin && !end) {
    return null
  }

  return (
    <div className="bg-fv-green-50 flex items-start p-2 border-fv-green-300 border mb-2">
      <Icon
        icon="calendar-day"
        className="text-fv-gray-dark"
        transform="down-2"
      />
      <p className="!mb-0">
        Delivery appointment scheduled for: {begin}
        {begin && end ? ` - ` : end ? 'before ' : ''}
        {end}
      </p>
    </div>
  )
}
